export default __webpack_public_path__ + "static/media/usda-logo-name.fa98e034.png";